
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/permanent/tag/[tag]",
      function () {
        return require("private-next-pages/permanent/tag/[tag].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/permanent/tag/[tag]"])
      });
    }
  